import { render, staticRenderFns } from "./PreAdd.vue?vue&type=template&id=315daede&"
import script from "./PreAdd.vue?vue&type=script&lang=js&"
export * from "./PreAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports